module.exports = __webpack_public_path__ + "img/join1.afade13d.png";